import React, { PureComponent } from 'react';
import { string, func, object, bool } from 'prop-types';
import Radium from 'radium';

import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';
import { appConfig } from 'config/customization';

import styles from './styles';
import CustomBanner from './components/CustomBanner';

class UTBanner extends PureComponent {
  render() {
    return appConfig.publicDashboard.usePublicBanner && !this.props.loading ? (
      <div style={[styles.container, this.props.containerStyle]}>
        {this.props.customBanner ? (
          <div
            style={[
              {
                backgroundImage: `url(${this.props.imageUrl})`
              },
              styles.contentContainer
            ]}
          >
            <CustomBanner onClick={this.props.onBannerClick} />
          </div>
        ) : (
          <UTTouchableWithoutFeedback
            onClick={this.props.onBannerClick}
            style={[styles.imageContainer, this.props.imageContainerStyle]}
          >
            <img src={this.props.imageUrl} alt="banner" style={styles.image} />
          </UTTouchableWithoutFeedback>
        )}
      </div>
    ) : null;
  }
}

UTBanner.propTypes = {
  onBannerClick: func,
  imageUrl: string,
  containerStyle: object, // eslint-disable-line react/forbid-prop-types
  imageContainerStyle: object, // eslint-disable-line react/forbid-prop-types
  customBanner: bool,
  loading: bool
};

export default Radium(UTBanner);
